import { Component, ViewChild } from '@angular/core';
import { BuscadorCotizadorComponent } from '../tools/buscador-cotizador/buscador-cotizador.component';
import { Router } from '@angular/router';
import { DatosCotizacion } from "../modelos/datos-cotizacion.model";
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from '../services/storage.service';
import { Configuration } from '../Constants/configuration';
import { StyleCocheSeguro } from '../modelos/styleCocheseguro.model';

@Component({
    selector: 'datos-vehiculo',
    templateUrl: './datos-vehiculo.component.html',
    styleUrls: ['./datos-vehiculo.component.css']
})
export class DatosVehiculoComponent {
    public const: Configuration = new Configuration();
    public styleCocheSeguro:StyleCocheSeguro = new StyleCocheSeguro();
    value: string = "";
    tipo: number;
    paquete: number;
    modelo: number = null;
    apiName: String = "QuattroAutosBuscador";
    aseguradoraId: number = 29;
    pickup: number = 0;
    negocioId: number = 0;
    tipoVehiculoBuscador: number = 0;
    abrevia: String = "";
    amis: string = "";
    tipoAuto: number = 0;
    tipoUnidad: number = 0;
    tipo_mkp: number = 1;
    @ViewChild('buscadorCotizador') buscadorCotizador: BuscadorCotizadorComponent;

    selectauto: any = {};
    datosCotizacion: DatosCotizacion = {
        multicotiza: {
            f1: new Configuration().MULTINEGOCIO_ID,
            f2: 29,
            f3: '',
            f4: new Date().getFullYear(),
            f5: 1,
            f7: 0
        },
        datosAuto: {
            paquete: 0,
            logoMarca: '',
            tipoUnidad: 0
        }
    };

    constructor(private router: Router, private snackBar: MatSnackBar, private storageService: StorageService) {
        if (this.storageService.ifExist("styleCocheSeguro")) {
            this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
        }
     }

    ngOnInit(){
    }

    tipoPaquete(valor: number) {
        this.tipo = valor;
    }

    obtenerAyuda() {
        console.log("Obtener Ayuda");
    }

    reiniciaAmis(event) {
        this.datosCotizacion.multicotiza.f3 = "";
        this.tipoAuto = 0;
        this.tipoUnidad = 0;
    }

    autosSalida(event) {
        //console.log("autosalida event => ", event);
        this.datosCotizacion.multicotiza.f3 = event.c1.c1;
        this.datosCotizacion.multicotiza.f4 = event.c1.c5;
        this.datosCotizacion.datosAuto.logoMarca = event.c1.c6;
        this.datosCotizacion.datosAuto.tipoUnidad = event.tipoUnidad;

        if (event.c1.c8) {
            this.datosCotizacion.multicotiza.f7 = event.c1.c8 == 2 ? 1 : 0;
        }
        //para demo va a homologar por Qualitas
        /*if (this.datosCotizacion.multicotiza.f5 === 1) {
            if (event.c1.c9) {  // c9 = 1 pickup
                this.datosCotizacion.multicotiza.f7 = event.c1.c9;
            }
        } else {
            this.datosCotizacion.multicotiza.f7 = this.datosCotizacion.multicotiza.f7 === 2 ? 1 : 0;
        }*/
        /*if (this.datosCotizacion.multicotiza.f7 != 0) {
        } else {
            //Se realizo esto para que cuando no se tenga el tipo de auto ir a buscar por modelo
            //this.tipoAuto = 99;
        }*/
    }

    next() {
        if (this.datosCotizacion.multicotiza.f3 == "") {
            this.snackBar.open("Selecciona un auto.", "", { duration: this.const.SNACK_BARTIME });
        } else {
            this.storageService.setItem("dataVehiculo", JSON.stringify(this.datosCotizacion));
            if (this.const.PLATFORM) {
                window.location.href = this.const.URLPLATFORM + 'cotizacion';
            } else {
                this.router.navigate(['cotizacion']);
            }
        }
    }
}
